import { createApp } from 'vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import Cookie from 'js-cookie';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; // or 'ant-design-vue/dist/antd.less'
import dayjs from '@/plugins/dayjs';
import i18n from '@/plugins/i18n';
import component from '@/plugins/componentToGlobal';
import AppFunctions from '@/utils/AppFunctions';
import ModalClass from '@/utils/modal';
import clickOutside from '@/directives/click-outside';
import VueLazyLoad from 'vue3-lazyload';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { createGtm } from "vue-gtm";
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'animate.css';
import './assets/style/style.scss';
import { messaging } from "./plugins/firebase";

const app = createApp(App);

app.directive('click-outside', clickOutside);
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$cookie = Cookie;
app.config.globalProperties.messaging = messaging;
app
  .use(createGtm({
    id: process.env.VUE_APP_GTM_ID,
    loadScript: true,
    vueRouter: router
  }))
  .use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    },
  })
  .use(VueLazyLoad)
  .use(i18n)
  .use(store)
  .use(router)
  .use(Antd)
  .use(component)
  .use(AppFunctions)
  .use(ModalClass)
  .use(CKEditor)
  .mount('#app');
